import Image from 'next/image'
import { FC } from 'react'

import { FileApiType } from '@/api/shared/types'
import { PreviewModal } from '@/components/shared/modal/ui/PreviewModal'

import { PreviewImagesSlider } from './PreviewImagesSlider'

type Props = {
  isModalOpen: boolean
  currentFiles: FileApiType[]
  activeIndex: number
  onClose: () => void
}

const FilesPreviewModal: FC<Props> = ({
  isModalOpen,
  currentFiles,
  activeIndex,
  onClose
}) => {
  return (
    <PreviewModal
      opened={isModalOpen}
      onClose={onClose}
      className="h-full w-full"
      contentClassName="flex justify-center items-center"
    >
      <>
        {currentFiles.length === 1 && (
          <Image
            src={currentFiles[0].link}
            alt={currentFiles[0].name}
            fill
            className="!static max-h-[90vh] w-full object-contain"
          />
        )}
        {currentFiles.length > 1 && (
          <PreviewImagesSlider
            files={currentFiles}
            onClose={onClose}
            initialSlide={activeIndex}
          />
        )}
      </>
    </PreviewModal>
  )
}

export default FilesPreviewModal
